// libraries
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { apiOrchestratorPricingCommittee } from '@store/apiSlices/apiSlices';

// interfaces
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import {
  IOrchestratorListResponse,
  IOrchestratorPricingCommittee,
} from '../../interfaces/interfaces';
import { CountryCode } from '@domains/country';

export const orchestratorPricingCommitteeList =
  apiOrchestratorPricingCommittee.injectEndpoints({
    endpoints: builder => ({
      getOrchestrators: builder.query<
        IOrchestratorPricingCommittee[],
        {
          country?: CountryCode;
          status: string;
          start_date?: string;
          end_date?: string;
          workflow_alias?: string;
        }
      >({
        query: params => ({
          url: `/retrieve-orchestrators`,
          params,
        }),
        transformErrorResponse: (error: FetchBaseQueryError) => {
          const modelError: ModelError = {
            errorStatus: error.status,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            messageFromServer: (error.data as any)?.message,
            serviceErrorName: 'getOrchestrators',
          };
          return modelError;
        },
        transformResponse: (
          response: IOrchestratorListResponse
        ): IOrchestratorPricingCommittee[] => {
          return response.orchestrators;
        },
        providesTags: (
          result,
          error,
          { country, status, start_date, end_date, workflow_alias }
        ) => [
          {
            type: 'CurrentOrchestrator' as const,
            id: `${country ?? 'all'}:${status}:${start_date ?? ''}:${end_date ?? ''}:${workflow_alias ?? ''}`,
          },
        ],
      }),
    }),
  });

export const { useGetOrchestratorsQuery } = orchestratorPricingCommitteeList;
